// Action Types
export const GET_AGENCY_PROJECTS = "VM_GET_AGENCY_PROJECTS";
export const SET_AGENCY_PROJECTS = "VM_SET_AGENCY_PROJECTS";
export const GET_VENDOR_TASKS = "VM_GET_VENDOR_TASKS";
export const SET_VENDOR_TASKS = "VM_SET_VENDOR_TASKS";

export const VM_GET_ASSIGNEE_PER_PROJECT = "VM_GET_ASSIGNEE_PER_PROJECT";
export const VM_SET_ASSIGNEE_PER_PROJECT = "VM_SET_ASSIGNEE_PER_PROJECT";

export const VM_UPLOAD_DELIVERABLE = "VM_UPLOAD_DELIVERABLE";
export const VM_DOWNLOAD_PO = "VM_DOWNLOAD_PO";
export const VM_RESPOND_TO_PO = "VM_RESPOND_TO_PO";
export const VM_UPDATE_ASSIGNEE_STATUS = "VM_UPDATE_ASSIGNEE_STATUS";
export const VM_DOWNLOAD_PARENT_FILE = "VM_DOWNLOAD_PARENT_FILE";
export const VM_DOWNLOAD_USER_INVOICE = "VM_DOWNLOAD_USER_INVOICE";
export const VM_UPDATE_PREFERRED_CURRENCY = "VM_UPDATE_PREFERRED_CURRENCY";
export const VM_UPDATE_BANK_DETAILS = "VM_UPDATE_BANK_DETAILS";
export const VM_UPDATE_UREED = "VM_UPDATE_UREED";
export const VM_UPDATE_PAYONEER = "VM_UPDATE_PAYONEER";
export const VM_UPDATE_CASH_EXPRESS = "VM_UPDATE_CASH_EXPRESS";
export const VM_UPDATE_VAT = "VM_UPDATE_VAT";

// Action Creators
export const getAgencyProjects = (agencyId, query, cb = () => {}) => ({
  type: GET_AGENCY_PROJECTS,
  agencyId,
  query,
  cb,
});

export const setAgencyProjects = (
  data = {
    result: [],
    count: 0,
  }
) => ({
  type: SET_AGENCY_PROJECTS,
  payload: data,
});

export const getVendorTasks = (vendorId, query, cb = () => {}) => ({
  type: GET_VENDOR_TASKS,
  vendorId,
  query,
  cb,
});

export const setVendorTasks = (
  data = {
    result: [],
    count: 0,
  }
) => ({
  type: SET_VENDOR_TASKS,
  payload: data,
});

export const getAssigneesPerProject = (agencyId, projectId, cb = () => {}) => ({
  type: VM_GET_ASSIGNEE_PER_PROJECT,
  agencyId,
  projectId,
  cb,
});

export const setAssigneesPerProject = (data = []) => ({
  type: VM_SET_ASSIGNEE_PER_PROJECT,
  payload: data,
});

export const uploadDeliverable = (assigneeId, payload, cb = () => {}) => ({
  type: VM_UPLOAD_DELIVERABLE,
  assigneeId,
  payload,
  cb,
});

export const downloadPo = (poId, cb = () => {}) => ({
  type: VM_DOWNLOAD_PO,
  poId,
  cb,
});

export const respondToPo = (assigneeId, acceptance, cb = () => {}) => ({
  type: VM_RESPOND_TO_PO,
  assigneeId,
  acceptance,
  cb,
});

export const downloadParentFile = (fileId, cb = () => {}) => ({
  type: VM_DOWNLOAD_PARENT_FILE,
  fileId,
  cb,
});

export const downloadUserInvoice = (poId, cb = () => {}) => ({
  type: VM_DOWNLOAD_USER_INVOICE,
  poId,
  cb,
});

export const updateAssigneeStatus = (assigneeId, status) => ({
  type: VM_UPDATE_ASSIGNEE_STATUS,
  assigneeId,
  status,
});

export const updatePreferredCurrency = (payload = {}, cb = () => {}) => ({
  type: VM_UPDATE_PREFERRED_CURRENCY,
  payload,
  cb,
});

export const updateBankDetailsCommon = (payload = {}, cb = () => {}) => ({
  type: VM_UPDATE_BANK_DETAILS,
  payload,
  cb,
});

export const updateUreedCommon = (payload = {}, cb = () => {}) => ({
  type: VM_UPDATE_UREED,
  payload,
  cb,
});
export const updatePayoneerCommon = (payload = {}, cb = () => {}) => ({
  type: VM_UPDATE_PAYONEER,
  payload,
  cb,
});

export const updateCashExpressCommon = (payload = {}, cb = () => {}) => ({
  type: VM_UPDATE_CASH_EXPRESS,
  payload,
  cb,
});

export const updateVat = (payload = {}, cb = () => {}) => ({
  type: VM_UPDATE_VAT,
  payload,
  cb,
});
